module.exports = __webpack_public_path__ + "static/media/rw-widgets.792dcd18.svg";